module.exports = __webpack_public_path__ + "static/img/382A4A_3_0.71bb661.svg";